// extracted by mini-css-extract-plugin
export var statItem = "_kc-1";
export var statsRow = "_kc-0";